import { AuthLayout } from "../../../components/AuthLayout";
import Logo from '../../../assets/images/logo.png';
import { Link } from "react-router-dom";
import { useMobile } from '../../../hooks/useMobile';



export const AuthLandingPage = () => {
    
    const isMobile = useMobile();
    return (
        <AuthLayout directory="#" showBackLink={false}>
            <div style={{ width: isMobile ? '80%' : '70%', backgroundColor: '#fff', margin: 'auto', borderRadius: '20px', boxShadow: '0px 4px 24px 0px #00000040', padding: '40px 30px', textAlign: 'center', fontFamily: 'Manrope", sans-serif', fontSize: '20px' }}>

                <img src={Logo} alt="Logo" style={{ width: '30%', height: 'auto'}} />
                <p style={{ color: '#1F2933', margin: '40px 0px' }}>Welcome to Oya Concierge — your premium concierge platform.</p>
                <Link to="/role-selection" style={{ display: 'block', textDecoration:'none', backgroundColor: '#14213D', color: '#fff', borderRadius: '10px', padding: '10px' }}>Create Account</Link>
                <Link to="/login" style={{ display: 'block', textDecoration:'none', borderRadius: '10px', padding: '10px', color: '#1F2933', border: '1px solid #C8A95B', marginTop: '20px' }}>Login</Link>
            </div>
            
        </AuthLayout>
    );
};